// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"16e9e682","453":"2e644801","983":"a818790a"}[chunkId] + ".chunk.js";
};